export const GET_PAST_BOOKINGS = 'get-past-bookings';
const getPastBookings = ({ fetchAll = false, query = [] }) => ({
  type: GET_PAST_BOOKINGS,
  payload: { fetchAll, query },
});
export default getPastBookings;
